/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsallbuyers2Inputs */

const en_ticketsallbuyers2 = /** @type {(inputs: Ticketsallbuyers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all buyers`)
};

const de_ticketsallbuyers2 = /** @type {(inputs: Ticketsallbuyers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Käufer ansehen`)
};

/**
* | output |
* | --- |
* | "View all buyers" |
*
* @param {Ticketsallbuyers2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsallbuyers2 = /** @type {((inputs?: Ticketsallbuyers2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsallbuyers2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsallbuyers2(inputs)
	return de_ticketsallbuyers2(inputs)
});
export { ticketsallbuyers2 as "ticketsAllBuyers" }